import { useTranslation } from 'react-i18next'

import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import colors from '@/assets/scss/_themes-vars.module.scss'

import PageContainer from '@/components/ui/containers/PageContainer'

import CreateWaitingRoomForm from './containers/CreateWaitingRoomForm'

export function CreateWaitingRoomPage() {
  const { t } = useTranslation()

  return (
    <PageContainer>
      <Paper>
        <Stack direction="row" alignItems="center" justifyContent="space-between" p={3}>
          <Stack spacing={1} sx={{ flex: 1 }}>
            <Typography variant="h2" component="div" noWrap sx={{ fontSize: { sm: '20px', lg: '24px' }, lineHeight: '28px', fontWeight: 700 }}>
              {t('page.createWaitingRoom.title')}
            </Typography>
            <Typography
              variant="subtitle1"
              component="div"
              noWrap
              sx={{ color: colors.gray500, fontSize: { sm: '16px', lg: '18px' }, lineHeight: '22px', fontWeight: 400 }}
            >
              {t('page.createWaitingRoom.subtitle')}
            </Typography>
          </Stack>
        </Stack>
        <Divider />
        <Box p={3}>
          <CreateWaitingRoomForm />
        </Box>
      </Paper>
    </PageContainer>
  )
}

export default CreateWaitingRoomPage
